module.exports = __webpack_public_path__ + "static/atlanta-afad3e68ec12e81e5db230ac913e9b48.png";